import { getStoryMediaId } from '../media/storyMediaItem';

export const primarySelectedMedia = (state) => state.story.selectedMedia[0];

export const activeSelectedMedia = (state) => {
  const { selectedMedia, selectedMediaActiveId } = state.story;

  if (!selectedMedia.length) {
    return null;
  }

  if (selectedMediaActiveId) {
    const active = selectedMedia.find((item) => getStoryMediaId(item) === selectedMediaActiveId);

    if (active) {
      return active;
    }
  }

  return selectedMedia[0];
};
